import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getTermCode } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, string>;

export const BeginGetTermCode: HandlerType = props => {
    props.dispatch({ type: "Custom/GetTermCode/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTermCode();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteGetTermCode: HandlerType = props => {
    props.dispatch({
        type: "Custom/GetTermCode/CompleteLoad",
        quoteCode: props.apiResult,
    });
};

export const chain = [BeginGetTermCode, RequestDataFromApi, CompleteGetTermCode];

const getWebTermCode = createHandlerChainRunner(chain, "CustomGetTermCode");
export default getWebTermCode;
